import { GET_SMOKING_PROBABILITY } from "./api-url.constants";
import { SmokingProbabilityDto } from "./dtos";
import { jsonFetch } from "@/lib/helpers";

export const getSmokingProbabilityByRoomId = async (
  roomId: string,
  monitorId?: string
): Promise<number> => {
  const url = monitorId
    ? `${GET_SMOKING_PROBABILITY}/${encodeURIComponent(roomId)}?monitorId=${encodeURIComponent(monitorId)}`
    : `${GET_SMOKING_PROBABILITY}/${encodeURIComponent(roomId)}`;
  const smokingProbabilityOutput = await jsonFetch<SmokingProbabilityDto>(url);
  return smokingProbabilityOutput.data.smokingProbability;
};
